import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TEmProductFileUploadsApi } from './types';

export const emProductFileUploads: TEmProductFileUploadsApi = {
	getUploadedFiles: payload =>
		http.post(endpoint.emProductFileUploads.UPLOADED_FILES, payload).then(r => r.data),
	uploadFile: payload => http.post(endpoint.emProductFileUploads.UPLOAD, payload).then(r => r.data),
	downloadFile: id =>
		http
			.get(endpoint.emProductFileUploads.DOWNLOAD(id), { responseType: 'blob' })
			.then(r => r.data),
	downloadProcessedFile: id =>
		http
			.get(endpoint.emProductFileUploads.DOWNLOAD_PROCESSED(id), { responseType: 'blob' })
			.then(r => r.data),
};
